var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isStationInfo(_vm.item))?_c('StationHeader',{attrs:{"stationInfo":_vm.item}}):(_vm.isLineDetails(_vm.item))?_c('LineInfo',{attrs:{"line":_vm.item}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }